<template>
  <v-row justify="center" align="start" class="fill-height pa-2 py-0">
    <v-col class="pb-0 pt-1">
      <slot />
    </v-col>
  </v-row>
</template>

<script>
export default {}
</script>
